// Configuração de versão do sistema
import { getEnvironmentVersion } from './environment.js'

// Obter versão do ambiente atual (fallback)
const ENV_VERSION = getEnvironmentVersion()

// Tenta obter da pipeline/ambiente
const ENV_VERSION_STRING = process.env.VUE_APP_VERSION
const ENV_BUILD = process.env.VUE_APP_BUILD
const ENV_CODENAME = process.env.VUE_APP_CODENAME
const ENV_RELEASE_DATE = process.env.VUE_APP_RELEASE_DATE

function parseSemver(versionString) {
  if (!versionString) return null
  const match = versionString.trim().match(/^v?(\d+)\.(\d+)\.(\d+)$/)
  if (!match) return null
  const [, major, minor, patch] = match
  return { major: Number(major), minor: Number(minor), patch: Number(patch) }
}

function getTodayBuild() {
  try {
    const d = new Date()
    const yyyy = d.getUTCFullYear()
    const mm = String(d.getUTCMonth() + 1).padStart(2, '0')
    const dd = String(d.getUTCDate()).padStart(2, '0')
    return `${yyyy}.${mm}.${dd}`
  } catch (e) {
    return ENV_VERSION.build || '0000.00.00'
  }
}

const parsed = parseSemver(ENV_VERSION_STRING)

export const APP_VERSION = parsed
  ? {
      major: parsed.major,
      minor: parsed.minor,
      patch: parsed.patch,
      build: ENV_BUILD || getTodayBuild(),
      releaseDate: ENV_RELEASE_DATE || new Date().toISOString().slice(0, 10),
      codename: ENV_CODENAME || 'CI Release'
    }
  : ENV_VERSION

// Função para obter a versão formatada
export function getVersionString() {
  return `v${APP_VERSION.major}.${APP_VERSION.minor}.${APP_VERSION.patch}`
}

// Função para obter a versão completa
export function getFullVersionString() {
  return `${getVersionString()} (${APP_VERSION.build})`
}

// Função para obter informações da versão
export function getVersionInfo() {
  return {
    version: getVersionString(),
    fullVersion: getFullVersionString(),
    build: APP_VERSION.build,
    releaseDate: APP_VERSION.releaseDate,
    codename: APP_VERSION.codename
  }
}

// Função para verificar se há uma nova versão disponível
export function checkForUpdates(currentVersion = getVersionString()) {
  return {
    current: currentVersion,
    latest: getVersionString(),
    hasUpdate: false,
    updateUrl: null
  }
}

// Função para obter informações detalhadas da versão
export function getDetailedVersionInfo() {
  return {
    ...getVersionInfo(),
    environment: process.env.NODE_ENV || 'development',
    timestamp: new Date().toISOString()
  }
}

export default APP_VERSION
